import React from "react"

// A read-only canvas preview of one block, mirroring the public ERB renderer.
// `imagesById` maps attachment id -> { url } so image blocks resolve.
export function BlockRenderer({ block, imagesById = {}, project }) {
  const props = block.props || {}

  switch (block.type) {
    case "heading": {
      const level = [1, 2, 3].includes(props.level) ? props.level : 2
      const size = level === 1 ? "text-2xl" : level === 2 ? "text-xl" : "text-base"
      return <div className={`${size} font-semibold text-slate-900`}>{props.text || "Heading"}</div>
    }
    case "text":
      return (
        <div
          className="prose prose-sm max-w-none text-slate-700"
          dangerouslySetInnerHTML={{ __html: props.html || "" }}
        />
      )
    case "image": {
      const img = imagesById[Number(props.image_id)]
      if (!img) return <Placeholder label="Image — pick one in settings" />
      return <img src={img.url} alt="" className={`w-full rounded-lg object-cover ${ratioClass(props.ratio)}`} />
    }
    case "image_gallery": {
      const urls = (props.image_ids || []).map((id) => imagesById[Number(id)]?.url).filter(Boolean)
      if (urls.length === 0) return <Placeholder label="Gallery — pick images in settings" />
      if (urls.length === 1) {
        return (
          <div className="relative">
            <img src={urls[0]} alt="" className={`w-full rounded-lg object-cover ${ratioClass(props.ratio)}`} />
            {props.show_posted_date && project?.launch_date && (
              <span className="absolute bottom-2 left-2 rounded-full bg-white/90 px-2 py-0.5 text-[11px] text-slate-500">
                Posted
              </span>
            )}
          </div>
        )
      }
      return (
        <div className="grid grid-cols-3 gap-1.5">
          {urls.map((u, i) => (
            <img key={i} src={u} alt="" className={`w-full rounded-md object-cover ${ratioClass(props.ratio)}`} />
          ))}
        </div>
      )
    }
    case "spec_grid": {
      const items = (props.items || []).filter((i) => i && i.value)
      if (items.length === 0) return <Placeholder label="Specs — add values in settings" />
      return (
        <div className="grid grid-cols-3 gap-4">
          {items.map((it, i) => (
            <div key={i}>
              <div className="text-[12px] text-slate-400">{it.label}</div>
              <div className="text-[15px] font-semibold text-slate-800">{it.value}</div>
            </div>
          ))}
        </div>
      )
    }
    case "divider":
      return <hr className="border-slate-200" />
    case "spacer":
      return <div style={{ height: props.size === "sm" ? 8 : props.size === "lg" ? 40 : 20 }} />
    default:
      return null
  }
}

function Placeholder({ label }) {
  return (
    <div className="flex h-16 items-center justify-center rounded-lg border border-dashed border-slate-200 text-[12px] text-slate-400">
      {label}
    </div>
  )
}

function ratioClass(ratio) {
  if (ratio === "4:3") return "aspect-[4/3]"
  if (ratio === "1:1") return "aspect-square"
  return "aspect-video"
}
